export const APPLICATION_STATUS = {
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    SUBMITTED: 'Submitted',
    UNDER_REVIEW: 'Under_review',
    REVIEWED: 'Reviewed'
};
export const APPLICATION_STATUS_LABELS = {
    [APPLICATION_STATUS.ACCEPTED]: 'Accepted',
    [APPLICATION_STATUS.REJECTED]: 'Rejected',
    [APPLICATION_STATUS.SUBMITTED]: 'Submitted',
    [APPLICATION_STATUS.UNDER_REVIEW]: 'Under Review',
    [APPLICATION_STATUS.REVIEWED]: 'Reviewed'
};

export const REVIEW_STATUS = {
    PENDING: 'Pending',
    REVIEWED: 'Reviewed'
};

export const REVIEWER_INVITATION_STATUS = {
    PENDING: 'Pending',
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected'
};